import React from 'react';
import {useEditVessel} from "../../../../contexts/EditVesselContext";
import {vesselForm} from "../constants";
import InputForm from "../../../../components/Basic/InputForm";

interface IProps {
}

const CleaningTime: React.FC<IProps> = () => {
    const [value, setStore] = useEditVessel(state => state.vessel?.cleaning_time);
    const [error] = useEditVessel(state => state.error?.cleaning_time)
    const {label, type, rules, suffix} = vesselForm.cleaning_time;

    const {[type]: Input} = InputForm;

    return <Input
        label={label}
        error={error}
        require={rules.requireZero}
        suffix={suffix}
        value={value ? value / 60000 : value}
        onChange={newValue => setStore(({vessel: old}) => ({vessel: {...old, cleaning_time: newValue * 60000}}))}
    />;
};

export default CleaningTime;